class ReassuranceDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.reassurance-drawer__overlay');
    this.inner = this.querySelector('.drawer__inner');

    this.overlay.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (e) => { if (e.code === 'Escape') this.close(); });
  }

  open(triggeredBy, activeTab) {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    if (activeTab) this.switchTab(activeTab);

    if (triggeredBy) {
      this.triggerElement = triggeredBy;
    }

    const firstFocusable = this.inner.querySelector('button, [tabindex]');
    if (firstFocusable) firstFocusable.focus();
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (this.triggerElement) this.triggerElement.focus();
  }

  switchTab(tabId) {
    this.querySelectorAll('.reassurance-drawer__panel').forEach((panel) => {
      panel.hidden = panel.dataset.tab !== tabId;
    });
    this.querySelectorAll('.reassurance-drawer__tab').forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.tab === tabId);
    });
  }
}

customElements.define('reassurance-drawer', ReassuranceDrawer);

document.querySelectorAll('[data-reassurance-trigger]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const drawer = document.querySelector('reassurance-drawer');
    if (drawer) drawer.open(btn, btn.dataset.reassuranceTrigger);
  });
});
